"use client";

import { Button, Heading } from "@pamperedchef/design-system";

interface ErrorProps {
	error: Error & { digest?: string };
	reset: () => void;
}

/**
 * Error page
 */
export default function Error(props: ErrorProps): JSX.Element {
	return (
		<div className="text-center p-md-4">
			<Heading tag="h1" styledAs="h1" className="mb-2 mb-xl-4">
				500 | Error
			</Heading>
			<Button kind="secondary" size="lg" onClick={props.reset}>
				Retry
			</Button>
		</div>
	);
}
